import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import {
  Input, List, Button, Spin,
} from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';

import MainLayout from '@common/layouts/MainLayout';
import Breadcrumb from '@common/containers/Breadcrumb';
import withAuth from '@common/hocs/withAuth';
import CenteredContent from '@common/components/ui/CenteredContent';

import AlarmRuleItem from './AlarmRuleItem';

import useAlarmas from './useAlarmas';
import styles from './Alarmas.module.less';

function Alarmas() {

  const { t } = useTranslation();
  const {
    alarmsList,
    requestAlarms,
    onChangeSearch,
    search,
    loading,
    hasMore,
    goToCreate,
    loadingNext,
    breadcrumbData,
    setValueFilter,
    arrayFilter,
    isCreate
  } = useAlarmas();

  return (
    <MainLayout applyPadding={false}>
      <div className={styles.wrapper}>
        <header className="bottom-shadow-none">
          <Breadcrumb breadcrumbData={breadcrumbData} />
        </header>
        <div className={styles.containerDiv}> 
          <Input
            placeholder={t('common.find')}
            className={styles.search}
            onChange={(e) => setValueFilter(e.target.value)} 
            suffix={<FontAwesomeIcon icon={faSearch} />}
            allowClear
          />
          {
            isCreate &&
              <Button className={styles.create_btn} type="primary" onClick={goToCreate}>
                <FontAwesomeIcon icon={faPlus} />
                {t('views.dynamic_alarms.buttons.create_alarm')}
              </Button>
          } 
        </div>
        <div id="scrollable_alarms" className={styles.list}>
          <InfiniteScroll
            dataLength={arrayFilter ? arrayFilter.length : 0}
            scrollableTarget="scrollable_alarms"
            next={() => requestAlarms({ forNext: true })}
            hasMore={hasMore}
          >
            <List
              loading={loading}
              dataSource={arrayFilter || []}
              rowKey={(item) => item.id}
              renderItem={(item) => <AlarmRuleItem {...item} />}
              // eslint-disable-next-line
              footer={(function () {

                if (!loadingNext) return null;
                return (
                  <CenteredContent>
                    <Spin />
                  </CenteredContent>
                );

              }())}
            />
          </InfiniteScroll>
        </div>
      </div>
    </MainLayout>
  );

}

export default withAuth(Alarmas);
